type PoolDidStatus = "held" | "reserved" | "released" | "deleted" | "unknown";
type PoolDidOrigin = "junction" | "sms" | "lvlt" | "xo" | "inteliq" | "flowroute";

export interface ApiPoolDid {
  Modified: string;
  Number: string;
  Origin: PoolDidOrigin;
  PoolDidId: string;
  Status: PoolDidStatus;
}

export interface PoolDid {
  modified: string;
  number: string;
  origin: PoolDidOrigin;
  poolDidId: string;
  status: PoolDidStatus;
}

export function apiPoolDidToPoolDid(apiPoolDid: ApiPoolDid): PoolDid {
  return {
    modified: apiPoolDid.Modified,
    number: apiPoolDid.Number,
    origin: apiPoolDid.Origin,
    poolDidId: apiPoolDid.PoolDidId,
    status: apiPoolDid.Status
  };
}
